import moment from 'moment';
import { FormControl, Validators } from '@angular/forms';
import { IDateRange } from 'app/models';
import { QuickRangeEvent } from '../date-quick-chips/date-quick-chips.component';
import { ILabel } from '../../models/machine.model';
import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnChanges,
} from '@angular/core';

@Component({
  selector: 'app-department-filter-component',
  templateUrl: './department.filter.component.html',
  styleUrls: ['./department.filter.component.scss'],
})
export class DepartmentFilterComponent implements OnInit, OnChanges {
  @Input()
  listOfDepartmentsFromApi: Array<ILabel> = [];

  @Input()
  selectedDepartment: string | undefined;

  @Output()
  selectedDepartmentChanged = new EventEmitter<string>();

  @Output()
  filterByDateChanged = new EventEmitter<IDateRange>();

  disabled = true;
  activeChip: string | null = null;
  listOfDepartments: Array<ILabel> = [];
  startDate = new FormControl(
    { value: moment().startOf('day'), disabled: this.disabled },
    Validators.required
  );
  endDate = new FormControl(
    { value: moment().endOf('day'), disabled: this.disabled },
    Validators.required
  );

  ngOnInit(): void {
    this.listOfDepartments = this.listOfDepartmentsFromApi;
  }

  ngOnChanges(changes: any): void {
    if (changes.listOfMachinesFromApi) {
      this.listOfDepartments = changes.listOfLabelsFromApi.currentValue;
    }
    if (changes.selectedMachine) {
      this.selectedDepartment = changes.selectedDepartment.currentValue;
    }
  }

  handleSelectChange() {
    this.disabled = true;
    this.selectedDepartmentChanged.emit();
    this.listOfDepartments = this.listOfDepartmentsFromApi;
  }

  handleRadioChange({ target }: Event) {
    const selectedDepartment = (target as HTMLElement).id;

    this.selectedDepartmentChanged.emit(selectedDepartment);
    this.handleFilterByDateChanged();

    this.disabled = false;
    this.startDate.enable();
    this.endDate.enable();
  }

  onQuickRange({ key, from, to }: QuickRangeEvent): void {
    this.activeChip = key;
    this.startDate.setValue(moment(from));
    this.endDate.setValue(moment(to));
    this.startDate.enable();
    this.endDate.enable();
    if (!this.disabled) {
      this.handleFilterByDateChanged();
    }
  }

  handleFilterByDateChanged(): void {
    this.filterByDateChanged.emit({
      startDate: moment(this.startDate.value).startOf('day'),
      endDate: moment(this.endDate.value).endOf('day'),
    });
  }
}
